import buildSubjectApiPath from '@Application/Subjects/buildSubjectApiPath';
import type * as React from 'react';
import documentImported, {
	type DocumentImportedAction,
} from '@Application/Beneficiaries/ImportedDocuments/Actions/documentImported';
import documentImportFailed, {
	type DocumentImportFailedAction,
} from '@Application/Beneficiaries/ImportedDocuments/Actions/documentImportFailed';
import type { ImportedDocumentPayload } from '@Application/Beneficiaries/ImportedDocuments/Actions/importedDocumentsFetched';
import type ImportDocument from '@Application/Beneficiaries/ImportedDocuments/Commands/ImportDocument';
import { postFormData } from '@Domain/Api';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';

type Actions = DocumentImportedAction | DocumentImportFailedAction;

export default (command: ImportDocument) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const subjectUrl = buildSubjectApiPath(command.facilityId, command.subject);
			const url =
				command.preparationId === null
					? `${subjectUrl}/imported-documents`
					: `${subjectUrl}/workflow-runs/${command.preparationId}/imported-documents`;
			const payload = await postFormData<ImportedDocumentPayload>(url, command.toFormData());

			const action = documentImported(payload, command.subject.typeKey, command.subject.subjectId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = documentImportFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
